import { openResponsivePopup } from "../../../../components/helpers";

(function(window, _, wattpad, utils, app) {
  "use strict";

  /**
   * Purpose: canonical way of adding user-reporting to a view
   *
   * Requirements:
   *    - a button in the dom with class `on-report`, with a `data-username` attribute
   *      set to the username of the user being reported
   *
   * Opens the `/webview/report/user/:username` webview flow in a responsive popup.
   *
   * @mixin ReportManagement
   */
  app.add(
    "ReportManagement",
    Monaco.Mixin.create({
      events: {
        "tap   .on-report": "onReport",
        "click .on-report": "stopEvent"
      },

      onReport: function(evt, noop) {
        wattpad.utils.stopEvent(evt);

        const reportedUsername = $(evt.currentTarget).data("username");
        if (!reportedUsername) {
          return;
        }

        const encodedReportedUsername = encodeURIComponent(reportedUsername);
        openResponsivePopup({
          url: `/webview/report/user/${encodedReportedUsername}`,
          width: 500,
          height: 700
        });
      }
    })
  );
})(window, _, wattpad, wattpad.utils, window.app);
